import { useState, useLayoutEffect, useCallback } from 'react';
export function useLoadMore() {
  const [loadMore, setLoadMore] = useState(false);
  useLayoutEffect(() => {
    const handleScroll = () => {
      const body = document.body;
      const html = document.documentElement;
      const height = Math.max(
        body.scrollHeight,
        body.offsetHeight,
        html.clientHeight,
        html.scrollHeight,
        html.offsetHeight,
      );
      if (
        window.innerHeight + window.scrollY + 5000 >
          height - window.innerHeight
      ) {
        setLoadMore(true);
        setTimeout(() => {
          setLoadMore(false);
        }, 0);
      } else {
        setLoadMore(false);
      }
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);
  return loadMore;
}
